// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#loadingbox[data-v-3de4aca5]{margin-top:20vw}[data-v-3de4aca5] .van-nav-bar{height:12vw}[data-v-3de4aca5] .van-nav-bar .van-nav-bar__content{line-height:12vw;height:12vw}[data-v-3de4aca5] .van-nav-bar .van-nav-bar__content .van-nav-bar__title{font-size:4.8vw}[data-v-3de4aca5] .van-nav-bar .van-nav-bar__content .van-icon{font-size:4.8vw;color:#1e1e1e}", ""]);
// Exports
module.exports = exports;
